import { useAuthCtx } from "../../Auth/useAuthCtx.ts";
import { getRolesFromAuth0User } from "../../Auth/getRolesFromAuth0User.ts";
import { KnownAuth0Roles } from "../../Auth/KnownAuth0Roles.ts";

export function Logo() {
  const { user } = useAuthCtx();
  const isAdmin = user
    ? getRolesFromAuth0User(user).includes(KnownAuth0Roles.Admin)
    : false;

  const image = (
    <img
      src="https://storage.googleapis.com/norma-dev-general/Norma-logo-with-name.png"
      alt="normaLogo"
      className="md:max-w-[300px] max-w-[200px]"
    />
  );

  if (!isAdmin) return image;

  return (
    <button
      type="button"
      className={"cursor-pointer hover:opacity-80 transition-opacity"}
    >
      {image}
    </button>
  );
}
